import { MediaClient } from '@atlaskit/media-client';
export var mediaClientsMap = new Map();
export var getMediaClient = function getMediaClient(mediaClientConfig) {
  // The Provider defines mediaClientConfig as required,
  // but integrators may skip it when using Media Card to display external images
  // i.e. a Media Client is not needed.
  // An empty mediaClientConfig object `{}` won't fall into this case,
  // but that case is handled internally by Media Client.
  if (!mediaClientConfig) {
    return new MediaClient({
      authProvider: function authProvider() {
        return Promise.resolve({
          clientId: '',
          token: '',
          baseUrl: ''
        });
      }
    });
  }
  var mediaClient = mediaClientsMap.get(mediaClientConfig);
  if (!mediaClient) {
    mediaClient = new MediaClient(mediaClientConfig);
    mediaClientsMap.set(mediaClientConfig, mediaClient);
  }
  return mediaClient;
};